import info from "../../../assets/icons/info-circle-white.svg";
import ImageUploading from "../../common/forms/ImageUploading";
import Upload from "../../../assets/icons/upload-010.svg";
import styled from "styled-components";
import XClose0 from "../../../assets/icons/x-close0.svg";

/**
 *
 * @param {Object} props - The component props.
 * @param {string} props.title - The name of the field.
 * @param {string} props.imageData - The image data to be displayed.
 * @param {function} props.setImageData - The function to set the image data.
 *
 */

/* #region SCOPED CSS */
const StyledImagePreview = styled.div`
    .upload-card,
    .upload-card * {
        box-sizing: border-box;
    }
    .upload-card {
        display: flex;
        flex-direction: column;
        gap: 4px;
        row-gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .frame-51 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        row-gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .store-facade {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-3-font-size, 10px);
        font-weight: var(--subtitle-3-font-weight, 400);
        position: relative;
    }
    .frame-197 {
        border-radius: 4px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-500, #141922);
        border-width: 0px 0px 0px 5px;
        display: flex;
        flex-direction: column;
        gap: 9px;
        row-gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 100%;
        position: relative;
    }
    .x-close-container {
        width: 6.667px;
        height: 6.667px;
        flex-shrink: 0;
        position: static;
        z-index: 8888;
    }
    .ellipse-5 {
        background: var(--text-and-icons-red-500, #ff3636);
        border-radius: 50%;
        width: 14px;
        height: 14px;
        position: absolute;
        //left: 766px;
        right: 12px;
        top: 12px;
    }
    .x-close {
        width: 12px;
        height: 12px;
        position: absolute;
        //left: 770px;
        right: 13px;
        top: 13px;
        overflow: visible;
        z-index: 8888;
        cursor: pointer;
    }
`;

const SmallFormFieldUploadStyles = styled.div`
    .frame-288 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        width: 100%;
        height: 100%;
    }
    .frame-199 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        text-align: center;
    }
    .frame-197 {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .browse-files-from-device {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-size: var(--subtitle-2-font-size, 14px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .logo-size-should-be-16-9-in-aspect-ratio-max-file-size-accepted-is-300-kb {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: center;
        font-size: var(--subtitle-3-font-size, 12px);
        font-weight: var(--subtitle-3-font-weight, 400);
        position: relative;
    }
`;
/* #endregion */

const SmallFormFieldUpload = props => {
    const { imageData, setImageData, title = "Profile Photo" } = props;

    return (
        <SmallFormFieldUploadStyles
            style={{
                display: "flex",
                flexDirection: "column",
                width: "120px"
            }}>
            <div
                style={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                    marginBottom: "5px"
                }}>
                <i
                    className="Icon fas fa-info-circle"
                    aria-hidden="true"
                    style={{
                        width: "10px",
                        height: "10px",
                        fontSize: "9px",
                        fontWeight: 500,
                        color: "var(--text-icons-gray-200)",
                        position: "relative",
                        top: "-2px"
                    }}></i>
                <div style={{ fontSize: "0.75rem", color: "var(--text-icons-gray-200)" }}>{title}</div>
            </div>
            <div
                style={{
                    backgroundColor: "#10141B",
                    width: "120px",
                    height: "126px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "5px",
                    border: "1px dashed #3C485A"
                }}>
                {imageData ? (
                    <ImagePreview
                        onCloseClicked={() => {
                            setImageData(null);
                        }}
                        imageBase64={imageData?.base64}
                        imageURL={imageData?.url}
                    />
                ) : (
                    <div className="frame-197">
                        <ImageUploading onImageUpload={data => setImageData(data)}>
                            <div className="frame-288">
                                <img className="upload-012" src={Upload} alt="" />
                            </div>
                        </ImageUploading>
                    </div>
                )}
            </div>
        </SmallFormFieldUploadStyles>
    );
};

export default SmallFormFieldUpload;

const ImagePreview = ({ imageURL, onCloseClicked, imageBase64, imgHasPadding = false, objectFit = "cover" }) => {
    let imageSource = imageURL;
    if (!imageURL && imageBase64)
        imageSource = imageBase64.startsWith("data:") ? imageBase64 : `data:image;base64,${imageBase64}`;

    return (
        <StyledImagePreview className="upload-card" style={{ width: "100%", height: "100%", position: "relative" }}>
            <img
                className="frame-197"
                style={{
                    //background: `url(${imageSource}) center / cover no-repeat`,
                    border: "0px",
                    minWidth: "0px",
                    maxWidth: "100%",
                    objectFit: objectFit,
                    padding: imgHasPadding ? "30px" : "0px"
                }}
                alt=""
                src={imageSource}></img>
            {onCloseClicked && (
                <div className="x-close-container">
                    <div className="ellipse-5"></div>
                    <img className="x-close" src={XClose0} alt="" onClick={onCloseClicked} />
                </div>
            )}
        </StyledImagePreview>
    );
};
